import FileSaver from 'file-saver';

export default {
    methods: {
        /**
         * @param {String} url
         * @param {Object} data
         * @return {undefined}
         */
        store({url, data}) {
            this.isRefreshing = true;
            axios.post(url, data, {
                responseType: 'blob',
            })
                .then(this.storeSuccess)
                .catch(this.handleErrorResponse)
                .then(() => this.isRefreshing = false);
        },

        /**
         * @param {Object} res
         * @return {boolean}
         */
        storeSuccess(res) {
            FileSaver.saveAs(res.data, this.getFileName(res));
            this.$emit('stored', {});
        },

        /**
         * @param {object} res
         */
        getFileName(res) {
            return _.chain(res)
                .get('headers.content-disposition', '')
                .thru(val => RegExp('filename="(.*?)"').exec(val))
                .get('1', 'download.csv')
                .value();
        },

        /**
         * @param {Object} response
         * @return {boolean}
         */
        async handleErrorResponse({response: {data, status}}) {
            const {errors, message} = JSON.parse(await data.text() || '{}');
            if (status === 422 && errors) {
                this.$message.error(message);
            } else if (message && _.isString(message)) {
                this.$message.error(message);
            }

            return false;
        },

        /**
         * @param {Object} item
         */
        download(item) {
            const data = _.omit(item, ['url']);
            const url = _.get(item, 'url');

            this.store({url: url, data: data});
        },
    },
};
